(function ($) {
  'use strict';

  /* Embedded tracking iframe: its src is set once the page itself has loaded
     (the tracking app is heavy and would otherwise compete with first paint),
     or after 2.5s if a slow third-party resource holds up the load event; the
     loading overlay is hidden when the frame loads. A cross-origin frame that
     a browser refuses to render still fires load, so the "open in a new tab"
     note under the frame is always visible as the fallback. */
  $(function () {
    var $loader = $('#to-loader');
    var $iframe = $('#to-iframe');
    if (!$iframe.length) return;

    var started = false;
    var done = function () { $loader.addClass('is-done'); };
    var start = function () {
      if (started) return;
      started = true;
      $iframe.on('load', done);
      $iframe.attr('src', $iframe.data('src'));
      setTimeout(done, 12000);
    };
    if (document.readyState === 'complete') start();
    else $(window).on('load', start);
    setTimeout(start, 2500);
  });
})(jQuery);

/* ---------- FAQ accordion (single open at a time) ---------- */
(function ($) {
  'use strict';
  $(function () {
    var $items = $('.sk-faq-item');
    $items.each(function () {
      var $item = $(this);
      var $toggle = $item.find('.js-faq-toggle');
      if (!$toggle.length) return;
      $toggle.on('click', function () {
        var willOpen = !$item.hasClass('open');
        $items.removeClass('open').find('.js-faq-toggle').attr('aria-expanded', 'false');
        if (willOpen) {
          $item.addClass('open');
          $toggle.attr('aria-expanded', 'true');
        }
      });
    });
  });
})(jQuery);
